import { Breakpoints, DesignTokenSizeEnum, InputAppearance, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { VehicleDetailsPageViewProps } from './VehicleDetailsPageViewProps';
import { TextInputField } from '../../modules/forms/fields/TextInputField';
import { Form } from '../../modules/forms/Form';
import { FieldsGroup } from '../../modules/common-components/FieldsGroup';

const StyledContentWrapper = styled.div<{ $isImageVisible: boolean }>`
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => props.theme.size.static150};

  ${(props) =>
    props.$isImageVisible &&
    `@media (min-width: ${Breakpoints.b960}px) {
    align-items: left;
  }`}
`;

const StyledDetailsWrapper = styled.div`
  flex-shrink: 0;
`;

const VehicleFormFields = React.memo(({ formData }: { formData: any }) => (
  <FieldsGroup paddingTop={DesignTokenSizeEnum.static400}>
    <TextInputField name="vin" label=" VIN/Chassis Number" type="text" appearance={InputAppearance.ReadOnly} />
    <TextInputField name="registrationNumber" label="Registration Number" type="text" appearance={InputAppearance.ReadOnly} />
    {formData.servicePlan && (
      <TextInputField name="servicePlan" label="Service/Maintenance Plan" type="text" appearance={InputAppearance.ReadOnly} />
    )}
    <TextInputField name="warrantyPlan" label="Warranty" type="text" appearance={InputAppearance.ReadOnly} />
  </FieldsGroup>
));

export function VehicleDetailsPageVwView({
 vehicleDetails,
 formData,
 formRef,
 vehicleImageDisplayed,
}: VehicleDetailsPageViewProps): ReactElement {
  return (
    <StyledContentWrapper $isImageVisible={vehicleImageDisplayed}>
      <StyledDetailsWrapper>
        <Form defaultValues={formData} ref={formRef}>
          <Text appearance={TokenTextAppearance.headline200} bold>
            {vehicleDetails.modelDescription}
          </Text>
          <VehicleFormFields formData={formData} />
        </Form>
      </StyledDetailsWrapper>
    </StyledContentWrapper>
  );
}
